import { render, staticRenderFns } from "./SerialPage.vue?vue&type=template&id=17863cb6&scoped=true&"
import script from "./SerialPage.vue?vue&type=script&lang=ts&"
export * from "./SerialPage.vue?vue&type=script&lang=ts&"
import style0 from "./SerialPage.vue?vue&type=style&index=0&id=17863cb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17863cb6",
  null
  
)

export default component.exports